import { createSlice, createAction } from '@reduxjs/toolkit';

// Saga-triggered actions
export const createClientInvoiceReportAction = createAction(
    'clientInvoiceReports/createReport',
);
export const fetchClientInvoiceReportsAction = createAction(
    'clientInvoiceReports/fetchReports',
);
export const pollClientInvoiceReportStatusAction = createAction(
    'clientInvoiceReports/pollReportStatus',
);
export const stopClientInvoicePollingAction = createAction(
    'clientInvoiceReports/stopPolling',
);
export const checkExistingClientInvoiceReportAction = createAction(
    'clientInvoiceReports/checkExisting',
);
export const deleteClientInvoiceReportAction = createAction(
    'clientInvoiceReports/deleteReport',
);

const initialState = {
    reports: [],
    total: 0,
    loading: false,
    creating: false,
    activeReport: null, // currently being polled
    existingReport: null, // same-day full report
    checkingExisting: false,
    error: null,
};

const clientInvoiceReportsSlice = createSlice({
    name: 'clientInvoiceReports',
    initialState,
    reducers: {
        setLoading(state, action) {
            state.loading = action.payload;
        },
        setCreating(state, action) {
            state.creating = action.payload;
        },
        reportsFetched(state, action) {
            state.reports = action.payload.reports;
            state.total = action.payload.total;
            state.loading = false;
        },
        reportCreated(state, action) {
            state.creating = false;
            state.activeReport = action.payload;
            // Prepend to list
            state.reports = [action.payload, ...state.reports];
            state.total += 1;
        },
        reportStatusUpdated(state, action) {
            const report = action.payload;
            state.activeReport = report;
            // Also update in list
            const idx = state.reports.findIndex(r => r._id === report._id);
            if (idx !== -1) {
                state.reports[idx] = report;
            }
        },
        clearActiveReport(state) {
            state.activeReport = null;
        },
        setExistingReport(state, action) {
            state.existingReport = action.payload;
            state.checkingExisting = false;
        },
        setCheckingExisting(state, action) {
            state.checkingExisting = action.payload;
        },
        reportDeleted(state, action) {
            state.reports = state.reports.filter(r => r._id !== action.payload);
            state.total = Math.max(0, state.total - 1);
        },
        setError(state, action) {
            state.error = action.payload;
            state.loading = false;
            state.creating = false;
        },
    },
});

export const {
    setLoading,
    setCreating,
    reportsFetched,
    reportCreated,
    reportStatusUpdated,
    clearActiveReport,
    reportDeleted,
    setExistingReport,
    setCheckingExisting,
    setError,
} = clientInvoiceReportsSlice.actions;

// Selectors
export const getClientInvoiceReports = state =>
    state.clientInvoiceReports.reports;
export const getClientInvoiceReportsTotal = state =>
    state.clientInvoiceReports.total;
export const getClientInvoiceReportsLoading = state =>
    state.clientInvoiceReports.loading;
export const getClientInvoiceReportsCreating = state =>
    state.clientInvoiceReports.creating;
export const getActiveClientInvoiceReport = state =>
    state.clientInvoiceReports.activeReport;
export const getExistingClientInvoiceReport = state =>
    state.clientInvoiceReports.existingReport;
export const getCheckingExistingClientInvoice = state =>
    state.clientInvoiceReports.checkingExisting;

export default clientInvoiceReportsSlice.reducer;
